import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
const DisplayFormattedMessage = ({ text, }) => {
    const lines = text.split("\n");
    return (_jsx(_Fragment, { children: lines.map((line, index) => (_jsxs(React.Fragment, { children: [line, index < lines.length - 1 && _jsx("br", {})] }, index))) }));
};
export default DisplayFormattedMessage;
